module.exports = __webpack_public_path__ + "img/image03.907a36b6.jpg";